import { Component, OnInit } from '@angular/core';

import { AuthService } from './shared/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  constructor(private readonly authService: AuthService) {
    // listen for logout triggered in other tabs
    addEventListener('storage', event => {
      if (event?.key?.includes('@@auth0spajs@@')) {
        if (event.newValue === null) {
          this.authService.logout();
        }
      }
    });
  }

  ngOnInit(): void {
    this.authService.checkTokenExpiry();
  }
}
